export const DEFAULT_HEADERS = { "Content-Type": "application/json" };
export const DEFAULT_REQUEST_OPTIONS = {
  method: "GET",
  headers: DEFAULT_HEADERS,
};
